import { Box } from '@mui/material';
import { ReactNode } from 'react';
import AppSidebar, { SIDEBAR_WIDTH } from './AppSidebar';

const AppLayout = ({ children }: { children: ReactNode }) => (
  <Box sx={{ display: 'flex', minHeight: '100vh' }}>
    <AppSidebar />
    <Box sx={{ flex: 1, ml: `${SIDEBAR_WIDTH}px`, bgcolor: 'background.default', minHeight: '100vh' }}>
      {children}
    </Box>
  </Box>
);

export default AppLayout;
